// src/components/ProtectedRoute.jsx
import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import i18n from '../i18n';

export default function ProtectedRoute() {
  const token = localStorage.getItem('token');

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem("language") || "en")
  }, [])

  // You can add more checks (token expiration, role, etc.)
  return token ? <Outlet /> : <Navigate to="/login" replace />;
}